<template>
  <b-row class="border-0">
    <b-col class="col-8 col-lg-6">
      <!-- Titel weergave in niet-edit modus -->
      <h5 class="mb-0 mt-0" v-if="!editable">{{ recipe.naam }}</h5>
      <i v-if="!editable">{{ kCalTotal > 0 ? kCalTotal + ' kCal pp' : '' }}</i>
      
      <!-- Titel weergave in edit modus -->
      <b-form-input
        v-if="editable"
        @update="$emit('update-recipe', recipe)"
        class="bg-transparent border-primary recipe-title-input"
        size="lg"
        placeholder="Receptnaam"
        v-model="recipeLocal.naam"
      />
      <i v-if="editable">{{ kCalTotal > 0 ? kCalTotal + ' kCal pp' : '' }}</i>
    </b-col>
    
    <!-- Desktop variant van edit knop -->
    <b-col cols="auto" class="ml-auto d-none d-lg-block mt-2 mt-sm-0">
      <b-button
        :variant="editable ? 'secondary ml-2' : 'primary ml-2'"
        title="Receptgegevens aanpassen"
        :pressed="false"
        @click="$emit('toggle-edit-mode')"
      >
        <b-icon
          :icon="editable ? 'pencil-fill' : 'pencil-fill'"
          :variant="editable ? 'dark' : 'white'"
        />
        {{ !editable ? 'Aanpassen' : 'Klaar' }}
      </b-button>
    </b-col>
    
    <!-- Mobile variant van navigatie knoppen -->
    <b-col cols="auto" class="ml-auto d-block d-lg-none p-0 mt-auto">
      <b-button
        class="ml-2 mr-2"
        @click="$router.push('/recipe-list');"
        :disabled="editable"
        :variant="editable ? 'secundary' : 'primary'"
      >
        <b-icon :icon="editable ? 'list-ul' : 'list-ul'" />
      </b-button>
      <b-button
        class="ml-2 mr-2"
        @click="$router.push('/shopping-list');"
        :disabled="editable"
        :variant="editable ? 'secundary' : 'primary'"
      >
        <b-icon :icon="editable ? 'basket2' : 'basket2-fill'" />
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'RecipeHeader',
  props: {
    recipe: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    kCalTotal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      recipeLocal: this.recipe
    };
  },
  watch: {
    recipe: {
      handler(newVal) {
        this.recipeLocal = newVal;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.recipe-title-input {
  font-size: 1.25rem !important;
  font-weight: 500;
  line-height: 1.2;
  padding: 0.5rem 0.75rem;
  min-height: 45px;
}

/* Zorg dat de input dezelfde visuele impact heeft als de h5 */
.recipe-title-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(85, 153, 75, 0.25);
}
</style>
